import React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';

import { TrackedButton, TrackedButtonProps } from '../../helpers/TrackedButton';
import Button, { ButtonProps } from 'antd/lib/button';

export const TrackedColoredButton: React.FC<TrackedButtonProps> = ({ children, ...props }) => {
    return (
        <TrackedButton
            {...props}
            size="large"
            color="default"
            style={{
                color: runwayColors.white,
                backgroundColor: antGrey.grey8,
                borderColor: antGrey.grey9,
            }}
        >
            {children}
        </TrackedButton>
    );
};

export const ColoredButton: React.FC<ButtonProps> = ({ children, ...props }) => {
    return (
        <Button
            {...props}
            size="large"
            color="default"
            style={{
                color: runwayColors.white,
                backgroundColor: antGrey.grey8,
                borderColor: antGrey.grey9,
            }}
        >
            {children}
        </Button>
    );
};
